import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';
import {
  validAFM,
  validEmail,
  validEmailNotMandatory,
  validGEMI,
  validIban,
  validPercentage,
  validPhoneNumber,
  validWebSite,
} from 'utils';
import {
  formFields,
  formFields1,
} from 'growth/mainForms/mainForm/components/terms/formField';
import { isString } from 'lodash';

const termFieldNames = [...formFields, ...formFields1]
  .map(it => it.name)
  .filter(it => it !== 'termsAll');

// -------------------------------------------------------------------------------------------------
// Validations for mainForm

// WIP. e.g. will see if user is needed etc.
export const validateInvestorApplication = ({
  user,
  formState,
  isValidCarrierUsers,
}) => {
  const tab1Validation = validateTab1(formState, isValidCarrierUsers);
  const tab2Validation = validateTab2(formState);
  const tab3Validation = validateTab3(formState);
  const tab4Validation = validateTab4(formState);
  const tab5Validation = validateTab5(formState);

  const details = {
    tab1: tab1Validation,
    tab2: tab2Validation,
    tab3: tab3Validation,
    tab4: tab4Validation,
    tab5: tab5Validation,
  };

  const valid = Object.values(details).every(it => it.valid);

  return {
    valid,
    details,
  };
};

const validateTab1 = (formState, isValidCarrierUsers) => {
  const tab11Validation = validateTab11(formState);
  const tab12Validation = validateTab12(formState, isValidCarrierUsers);
  const tab13Validation = validateTab13(formState);

  const details = {
    tab11: tab11Validation,
    tab12: tab12Validation,
    tab13: tab13Validation,
  };
  const valid = Object.values(details).every(it => it.valid);

  return {
    valid,
    details,
  };
};

const validateTab11 = formState => {
  const { carrier } = formState;
  // In the validateTab11 function
  const details = {
    // Στοιχεία Φορέα Επένδυσης
    abiGcrCode: !carrier?.abiGcrCode || validGEMI(carrier?.abiGcrCode),
    companyName: Boolean(carrier?.companyName),
    legalVat: validAFM(carrier?.legalVat),
    companyLegalType: Boolean(carrier?.companyLegalType),
    // Check gia business size - mono 'Πολύ Μικρή' or 'Μικρή'
    businessSize: Boolean(carrier?.businessSize),

    // Διεύθυνση Έδρας Επιχείρησης
    // abiDistrict: Boolean(carrier?.abiDistrict),
    buildStreet: Boolean(carrier?.buildStreet),
    buildTk: Boolean(carrier?.buildTk),
    legalPhoneMobile: validPhoneNumber(carrier?.legalPhoneMobile),
    legalEmail: validEmail(carrier?.legalEmail),
  };

  const valid = Object.values(details).every(Boolean);

  return {
    valid,
    details,
  };
};

const validateTab12 = (formState, isValidCarrierUsers) => {
  const { carrier } = formState;

  const details = {
    // Υπάρχουν άλλοι Εταίροι/Μέτοχοι στον Φορέα της Επένδυσης;
    hasShareholdersFlag:
      carrier?.hasShareholdersFlag === false ||
      (carrier?.carrierUsers?.every(it =>
        Boolean(
          it.shareholderName &&
            validAFM(it.shareholderVat) &&
            it.shareholderCountry &&
            it.shareholderPercentage &&
            validPercentage(
              parseFloat(it.shareholderPercentage?.replaceAll(',', '.'))
            )
        )
      ) &&
        isValidCarrierUsers),
  };

  const valid = Object.values(details).every(Boolean);

  return {
    valid,
    details,
  };
};

const validateTab13 = formState => {
  const { carrier } = formState;
  const beneficialOwners = carrier?.beneficialOwners;

  if (!Array.isArray(beneficialOwners) || beneficialOwners.length === 0) {
    return {
      valid: false,
      details: { beneficialOwnersExists: false },
    };
  }

  const fullName = beneficialOwners.every(
    owner =>
      isString(owner.fullName) &&
      owner.fullName.trim().length > 0 &&
      owner.fullName.trim().length <= 80
  );

  const taxId = beneficialOwners.every(
    owner => isString(owner.taxId) && validAFM(owner.taxId)
  );

  const birthDate = beneficialOwners.every(owner => !!owner.birthDate);

  const participationValidEach = beneficialOwners.every(
    owner =>
      !isNil(owner.participationPercentage) &&
      Number(owner.participationPercentage) >= 0 &&
      Number(owner.participationPercentage) <= 100
  );

  const participationTotal =
    beneficialOwners.reduce(
      (accumulator, currentValue) =>
        accumulator + Number(currentValue.participationPercentage || 0),
      0
    ) === 100;

  const participationPercentage = participationValidEach && participationTotal;

  const role = beneficialOwners.every(
    owner =>
      isString(owner.role) &&
      owner.role.trim().length > 0 &&
      owner.role.trim().length <= 50
  );

  const details = {
    beneficialOwnersExists: true,
    fullName,
    taxId,
    birthDate,
    participationPercentage,
    role,
  };

  const valid = Object.values(details).every(Boolean);

  return {
    valid: valid,
    details: details,
  };
};

const validateTab2 = formState => {
  const { documents, carrier } = formState;
  const atomiki = carrier.companyLegalType === 'SP';

  const details = {
    investmentExpenditures: Boolean(documents?.investmentExpenditures),
    accumulationDeclaration: Boolean(documents?.accumulationDeclaration),
    taxFormE3: Boolean(documents?.taxFormE3),
    beneficialOwnersDeclaration: Boolean(
      documents?.beneficialOwnersDeclaration
    ),
    beneficialOwnersRegistryPrintout: atomiki
      ? true
      : Boolean(documents?.beneficialOwnersRegistryPrintout),
    gemiChangesCertificate: atomiki
      ? true
      : Boolean(documents?.gemiChangesCertificate),
  };

  const valid = Object.values(details).every(Boolean);

  return {
    valid,
    details,
  };
};

const validateTab3 = formState => {
  const tab31Validation = validateTab31(formState);
  const tab32Validation = validateTab32(formState);
  const tab34Validation = validateTab34(formState);

  const details = {
    tab31: tab31Validation,
    tab32: tab32Validation,
    tab34: tab34Validation,
  };
  const valid = Object.values(details).every(it => it.valid);

  return {
    valid,
    details,
  };
};

const validateTab31 = formState => {
  const { carrier } = formState;
  const jsonData = carrier?.dapanesEpendysis
    ? JSON?.parse(carrier?.dapanesEpendysis)
    : {};
  const ependutikoSxedio = jsonData?.ependutikoSxedio;
  // const toposEkteleshs = jsonData?.toposEkteleshs;
  const details = {
    // Στοιχεία Επενδυτικού Σχεδίου
    titlos: Boolean(ependutikoSxedio?.titlos),
    kwdikosKad: Boolean(ependutikoSxedio?.kwdikosKad),
    enarksh: Boolean(ependutikoSxedio?.enarksh),
    oloklhrwsh: Boolean(ependutikoSxedio?.oloklhrwsh),
    perigrafi: Boolean(ependutikoSxedio?.perigrafi),

    // Χρηματοδοτικά Εργαλεία Επένδυσης
    investmentFinancing:
      !carrier?.investmentFinancing ||
      Boolean(carrier?.investmentFinancingValue),
    otherInvestmentFinancing:
      !carrier?.otherInvestmentFinancing ||
      Boolean(carrier?.otherInvestmentFinancingValue),
    // investmentFinancingValue: Boolean(carrier?.investmentFinancingValue),
    // otherInvestmentFinancingValue: Boolean(carrier?.otherInvestmentFinancingValue),

    // Τόπος Εκτέλεσης Επενδυτικού Σχεδίου
    // periferia: Boolean(toposEkteleshs?.periferia),
    // periferiakiEnotita: Boolean(toposEkteleshs?.periferiakiEnotita),
    // dimos: Boolean(toposEkteleshs?.dimos),
    // topos: Boolean(toposEkteleshs?.topos),
  };

  const valid = Object.values(details).every(Boolean);

  return {
    valid,
    details,
  };
};

const validateTab32 = formState => {
  const { carrier } = formState;

  const details = {
    // TODO
    todo: true,
  };

  const valid = Object.values(details).every(Boolean);

  return {
    valid,
    details,
  };
};

const validateTab34 = formState => {
  const { carrier } = formState;

  const details = {
    // Στοιχεία Επενδυτικού Σχεδίου
    activityField: Boolean(carrier?.activityField),
    operatingMonths:
      carrier?.activityField === 'other' || Boolean(carrier?.operatingMonths),
    roomsNum: carrier?.activityField === 'other' || Boolean(carrier?.roomsNum),
    occupancyRate:
      carrier?.activityField === 'other' ||
      Boolean(
        carrier?.occupancyRate &&
          validPercentage(parseFloat(carrier?.occupancyRate))
      ),
    avgRoomDailyRate:
      carrier?.activityField === 'other' ||
      Boolean(carrier?.avgRoomDailyRate && carrier.avgRoomDailyRate !== '0,00'),
    estimatedQuantity:
      carrier?.activityField === 'tourist' ||
      Boolean(carrier?.estimatedQuantity),
    avgSellingPrice:
      carrier?.activityField === 'tourist' ||
      Boolean(carrier?.avgSellingPrice && carrier.avgSellingPrice !== '0,00'),
  };

  const valid = Object.values(details).every(Boolean);

  return {
    valid,
    details,
  };
};

const validateTab4 = formState => {
  const { carrier } = formState;

  const details = {
    // Πιστωτικό Ίδρυμα
    bnkBank: Boolean(carrier?.bnkBank),
  };

  const valid = Object.values(details).every(Boolean);

  return {
    valid,
    details,
  };
};

const validateTab5 = formState => {
  const { terms } = formState;

  // Terms
  const details = termFieldNames.reduce((acc, name) => {
    acc[name] = Boolean(terms?.[name]);
    return acc;
  }, {});

  const valid = Object.values(details).every(Boolean);

  return {
    valid,
    details,
  };
};
